// import BreakingNews from './components/breaking-news.component';
// import TrendingTopicsWidget from './components/trending-topics-widget.component';
// import WritingMotivationWidget from './components/writing-motivation-widget.component';
// import SeedOpportunitiesWidget from './components/seed-opportunities-widget.component';
import TrendingCrossPlatformStory from './components/trending-cross-platform-story.component';
// import Cookies from 'js-cookie';

const RightContentComponent = () => {
  // const token = Cookies.get('token');

  return (
    <div className="w-full">
      <div className="flex flex-col gap-[36px] w-full overflow-y-auto overflow-x-hidden p-1">
        {/* Writing Motivation - Only for logged-in users */}
        {/* {token && <WritingMotivationWidget />} */}

        {/* Seed Opportunities - Show for all users (with different content based on auth status) */}
        {/* <SeedOpportunitiesWidget />
        <TrendingTopicsWidget /> */}
        {/* <BreakingNews /> */}
        <TrendingCrossPlatformStory />
      </div>
    </div>
  );
};

export default RightContentComponent;
